import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './navbar.css';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`navbar navbar-expand-lg navbar-dark fixed-top ${scrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <NavLink className="navbar-brand" to="/">
                    <span className="brand-text">AngularStone</span>
                </NavLink>

                <button 
                    className={`navbar-toggler ${menuOpen ? 'open' : ''}`}
                    type="button"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span className="toggler-icon"></span>
                </button>

                <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`}>
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item">
                            <NavLink 
                                className={({isActive}) => 
                                    `nav-link ${isActive ? 'active' : ''}`
                                }
                                to="/"
                                onClick={() => setMenuOpen(false)}
                            >
                                <span className="nav-text">Inicio</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink 
                                className={({isActive}) => 
                                    `nav-link ${isActive ? 'active' : ''}`
                                }
                                to="/servicios"
                                onClick={() => setMenuOpen(false)}
                            >
                                <span className="nav-text">Servicios</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
